import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import PublicLayout from "@/components/PublicLayout";
import HomePage from "@/pages/HomePage";
import RequestPage from "@/pages/RequestPage";
import RequestConfirmation from "@/pages/RequestConfirmation";
import SimulatorPage from "@/pages/SimulatorPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ZonesPage from "@/pages/ZonesPage";
import CityPage from "@/pages/CityPage";
import CityCatchAll from "@/pages/CityCatchAll";
import DepartmentPage from "@/pages/DepartmentPage";
import PricingPage from "@/pages/PricingPage";
import ProfessionalsPage from "@/pages/ProfessionalsPage";
import TrackingPage from "@/pages/TrackingPage";
import ContactPage from "@/pages/ContactPage";
import ReviewsPage from "@/pages/ReviewsPage";
import AboutPage from "@/pages/AboutPage";
import LegalPages from "@/pages/LegalPages";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminRequestDetail from "@/pages/admin/AdminRequestDetail";
import AdminDrivers from "@/pages/admin/AdminDrivers";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminPartners from "@/pages/admin/AdminPartners";
import AdminTariffs from "@/pages/admin/AdminTariffs";
import AdminServices from "@/pages/admin/AdminServices";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminQuotes from "@/pages/admin/AdminQuotes";
import AdminContactMessages from "@/pages/admin/AdminContactMessages";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminFaqs from "@/pages/admin/AdminFaqs";
import AdminZones from "@/pages/admin/AdminZones";
import AdminPageContent from "@/pages/admin/AdminPageContent";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";

export default function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/demande" element={<RequestPage />} />
            <Route path="/demande/confirmation/:requestNumber" element={<RequestConfirmation />} />
            <Route path="/simulateur" element={<SimulatorPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/zones" element={<ZonesPage />} />
            <Route path="/zones/:slug" element={<CityPage />} />
            <Route path="/departement/:slug" element={<DepartmentPage />} />
            <Route path="/tarifs" element={<PricingPage />} />
            <Route path="/professionnels" element={<ProfessionalsPage />} />
            <Route path="/suivi" element={<TrackingPage />} />
            <Route path="/suivi/:requestNumber" element={<TrackingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/avis" element={<ReviewsPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/mentions-legales" element={<LegalPages page="mentions" />} />
            <Route path="/cgv" element={<LegalPages page="cgv" />} />
            <Route path="/confidentialite" element={<LegalPages page="confidentialite" />} />
            <Route path="/cookies" element={<LegalPages page="cookies" />} />
            {/* SEO city pages: /depannage-remorquage-:slug — handled via splat
                because React Router v6 doesn't support partial-segment params */}
            <Route path="*" element={<CityCatchAll />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="demandes" element={<AdminRequests />} />
            <Route path="demandes/:id" element={<AdminRequestDetail />} />
            <Route path="devis" element={<AdminQuotes />} />
            <Route path="messages" element={<AdminContactMessages />} />
            <Route path="chauffeurs" element={<AdminDrivers />} />
            <Route path="clients" element={<AdminCustomers />} />
            <Route path="partenaires" element={<AdminPartners />} />
            <Route path="tarifs" element={<AdminTariffs />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="avis" element={<AdminReviews />} />
            <Route path="faqs" element={<AdminFaqs />} />
            <Route path="zones" element={<AdminZones />} />
            <Route path="contenu" element={<AdminPageContent />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="parametres" element={<AdminSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
